import {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import Page from 'components/Page';
import {ChooseForm} from './components/ChooseForm/ChooseForm';

function ChoosePlanView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const bottomPanelRef = useRef<HTMLDivElement>(null);

  const onBackClick = () => {
    navigate(getFullPath(PATHS.esim.manage), {replace: true});
  };

  return (
    <Page
      title={t('esim.plans')}
      navBarTitle={t('esim.plans')}
      onBackButtonClick={onBackClick}
      hideSubPanelBackButton={true}
      isSubHeaderVisible
      bottomStickyPanelRef={bottomPanelRef}
    >
      <div className="flex gap-20 w-full flex-wrap">
        <ChooseForm bottomPanelRef={bottomPanelRef} />
      </div>
    </Page>
  );
}

export {ChoosePlanView};
